export const registrationForm = {
  registrationAlias: "Apelido",
  registrationName: "Nome",
  registrationLastName: "Sobrenome",

  registrationEmail: "E-mail",
  registrationEmail_message: "Digite um e-mail válido",
  registrationEmail_required: "O e-mail é obrigatório",
  registrationEmail_specialChar:
    "Caracteres especiais não permitidos: apóstrofo, aspas, acento, letra ç, etc.",
  registrationEmail_CharStartEnd: "O e-mail não pode começar nem terminar com caracteres especiais",
  registrationEmail_CharConsecutive: "O e-mail não pode ter caracteres especiais seguidos",

  registrationPhoneNumber: "Celular",
  registrationPhoneNumber_message: "Digite um número de celular válido",
  registrationPhoneNumber_tooltip: "O celular cadastrado será usado para validar o Pago Móvil.",
  registrationBirthdate: "Data de nascimento",
  registrationBirthdate_message: "Você precisa ter mais de 18 anos para se cadastrar",
  registrationNational_id: "Documento",
  registrationId_message: "Digite seu documento",
  registrationNationalIdNumbersOnly: "Só são permitidos números de 0 a 9",
  registrationState: "Estado",
  registrationSelect_state: "Selecione um estado",
  registrationCity: "Cidade",
  registrationSelect_city: "Selecione uma cidade",
  registrationSelectDate: "Data de nascimento",
  registrationPassword: "Senha",
  registrationPasswordMinLength: "A senha precisa ter no mínimo 8 caracteres",
  registrationRepeatPassword: "Repetir senha",
  registrationRepeatPassword_required: "Repita sua senha",
  registrationPasswordNotMatch: "As senhas não conferem",
  registrationReferralCode: "Código de indicação (opcional)",
  registrationTermsAndConditions: "termos e condições",
  registrationTermsAndConditions_: "Aceito os",
  registrationAcceptTerms: "Você precisa aceitar os termos e condições",
  registrationAcceptTermsAgeCondition: "e confirmo ter mais de 18 anos",
  registrationAcceptTermsRegister: "Cadastrar-se",

  registrationAliasUnavailable: "Este apelido já está em uso, tente outro",
  registrationAliasChecking: "Verificando disponibilidade do apelido...",
  registrationAliasAvailable: "Este apelido está disponível",

  registrationAccountValidationModal: "Erro no cadastro",
  registrationValidationModalEmail:
    "Este usuário já está cadastrado. Entre na sua conta ou use outro e-mail para se cadastrar.",
  registrationValidationModalPhone: "Celular já cadastrado, use outro número.",
  registrationValidationModalId: "Documento já cadastrado, use outro documento.",
  registrationValidationModalError: "Ocorreu um erro, confira seus dados.",
  registrationBonusTitle: "Bônus de boas-vindas",
  registrationFormBonusSlot: "Slots",
  registrationFormBonusCasino: "Cassino ao vivo",
  registrationFormBonusParley: "Múltiplas",

  registrationSuccessTitle: "Cadastro concluído!",
  registrationSuccessMessage: "Bem-vindo! Você já está conectado.",
  registrationError: "Erro no cadastro",
  registrationErrorMessage:
    "O cadastro foi concluído, mas não conseguimos entrar automaticamente. Faça o login manualmente.",
};
